export default "__VITE_ASSET__D55xBzRI__"